import { DOCS_LINKS } from '../constants/docsLinks';

export const DEFAULT_SUPPORT_BOOKING_URL =
  'https://app.reclaim.ai/m/qualz-info-session/qualz-information-session';
export const DEFAULT_INTERVIEW_SHARE_DOCS_URL = DOCS_LINKS.interviewShare;

export const SUPPORT_BOOKING_URL =
  import.meta.env.VITE_WORKSPACE_ACTIVATION_MEETING_URL || DEFAULT_SUPPORT_BOOKING_URL;
export const INTERVIEW_SHARE_DOCS_URL =
  import.meta.env.VITE_INTERVIEW_SHARE_DOCS_URL || DEFAULT_INTERVIEW_SHARE_DOCS_URL;

export const SALES_CONTACT_EMAIL = import.meta.env.VITE_SALES_CONTACT_EMAIL || 'sales@qualz.ai';
